import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import * as Icon from 'react-feather';
import { listBadNumbers } from '../../../store/slices/tenantSlices/configurationSlice';

const ListUploadSuccessModal = ({ isOpen, onDoneClick, recordDetails }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleBadNumberClick = async () => {
    try {
      setLoading(true);
      const response = await dispatch(listBadNumbers(recordDetails?.list_id)).unwrap();
      const url = window.URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = url;
      link.download;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} size="lg" centered backdrop>
      <ModalBody>
        <div className="d-flex flex-column justify-content-between align-items-center pt-4">
          <Icon.CheckCircle size={60} className="text-success" />

          <div className="fs-4 py-2">File uploaded successfully</div>

          <div className="fs-6 pt-2 w-100">
            <table className="report-list-table">
              <thead>
                <tr>
                  <th>Inserted Count</th>
                  <th>Duplicate Count</th>
                  <th>Bad Number Count</th>
                  <th>DNC Count</th>
                  <th>Total Records</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{recordDetails?.insertedCount || 0}</td>
                  <td>{recordDetails?.duplicateCount || 0}</td>
                  <td>
                    {Number(recordDetails?.badNumberCount) > 0 ? (
                      <span
                        role="button"
                        onClick={handleBadNumberClick}
                        style={{
                          textDecoration: 'underline',
                          cursor: 'pointer',
                          color: '#122335'
                        }}>
                        {recordDetails?.badNumberCount || 0}
                      </span>
                    ) : (
                      recordDetails?.badNumberCount || 0
                    )}
                  </td>
                  <td>{recordDetails?.dncCount || 0}</td>
                  <td>{recordDetails?.totalRecords || 0}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ModalBody>

      <ModalFooter className="justify-content-center">
        <Button onClick={onDoneClick} className="px-5 bg-primary border-primary" disabled={loading}>
          {loading ? 'Please wait...' : 'Continue'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ListUploadSuccessModal.propTypes = {
  isOpen: PropTypes.bool,
  recordDetails: PropTypes.object,
  onDoneClick: PropTypes.func
};

export default ListUploadSuccessModal;
